"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getAllOptions_1 = require("./getAllOptions");
var mobx_1 = require("mobx");
var owa_workloads_1 = require("owa-workloads");
var quickOptions = mobx_1.computed(function () {
    return getAllOptions_1.default()
        .filter(function (option) {
        return !!option.quickOptionSettings &&
            owa_workloads_1.getOwaWorkload() & option.quickOptionSettings.workloads;
    })
        .sort(function (a, b) { return a.quickOptionSettings.order - b.quickOptionSettings.order; });
});
exports.default = function () { return quickOptions.get(); };
//# sourceMappingURL=getQuickOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/selectors/getQuickOptions.js
// module id = 5278
// module chunks = 2